<template>
    <div class="draw-layer">
        <div class="bg-01">
            <div class="content">
                <div class="banner">
                    <div class="banner-pic animated fadeInDown"></div>
                    <div class="time animated bounceIn"></div>
                     <ul>
                <li class="btn1">剩余奖品数量: {{ prizeNumber }}</li>
                <li class="btn2">已参加人数: {{ personNumber }}</li>
            </ul>
                </div>
            </div>
        </div>
        <div class="bg-02">
           
        </div>
        <div class="bg-03">
            <div class="barrage-list">
                <!--弹幕-->
                <vue-danmaku ref="danmaku" :danmus="barrageDataList" v-bind="config" use-slot loop>
                    <template slot="dm" slot-scope="{ danmu }">
                        <div class="msg">
                            <p>{{ danmu.roleName }}：{{ danmu.content }}</p>
                            <span v-if="danmu.itemId!=0"></span>
                        </div>
                    </template>
                    <div></div>
                </vue-danmaku>
                <!--弹幕 end-->
            </div>
            <div class="login-status">
                <!--登录状态-->
                <div v-if="isLogin">
                    <!-- <div class="current-info">活动大区：<p>{{ userName }}</p><a href="http://passport.ourgame.com/passportlogin.do?from=ourgame&nexturl=http://fmz.ourgame.com">注销</a> <el-button type="text" @click="logOut">注销</el-button></div> -->
                    <div class="current-info">活动大区：<p>盘古大陆</p><a href="http://passport.ourgame.com/lzgamelogout!webhall.do?nexturl=http://fmz.ourgame.com/activity/barrage/index.html" style="color:#ffffff;">退出登录</a> </div>
                    <el-form :model="msgForm" :rules="rules" ref="msgForm" label-width="0" class="msg-ruleForm">
                        <el-form-item label="" prop="gmServer">
                            <el-select v-model="msgForm.gmServer" placeholder="请选择服务器" @change="getRoleBy">
                                <el-option v-for="item in serverList" :key="item.serverid" :label="item.servername" :value="item.serverid"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" prop="roles">
                            <el-select v-model="msgForm.roles" placeholder="请选择角色">
                                <el-option v-for="item in roleList" :key="item.roleName" :label="item.roleName" :value="item.roleName"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" prop="desc">
                            <el-input type="textarea" maxlength="22" placeholder="我为伏魔送祝福" v-model="msgForm.desc"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="send-msg animate-pictrue" @click="sendMsg('msgForm')"></div>
                    <ul>
                        <li class="animate-pictrue"><a href="javascript:void(0)" @click="recordDialog"><img src="../../assets/images/barrage/btn4.png" alt=""></a></li>
                        <li class="animate-pictrue"><a href="javascript:void(0)" @click="activityRules('rules')"><img src="../../assets/images/barrage/btn6.png" alt=""></a></li>
                    </ul>
                </div>
                <!--登录状态 end-->
                <!--未登录状态-->
                <ul class="login" v-else>
                    <li class="animate-pictrue"><a href="http://passport.ourgame.com/passportlogin.do?from=star&nexturl=http://fmz.ourgame.com/activity/barrage/index.html"><img src="../../assets/images/barrage/btn5.png" alt=""></a></li>
                    <li class="animate-pictrue"><a href="javascript:void(0)" @click="activityRules('rules')"><img src="../../assets/images/barrage/btn6.png" alt=""></a></li>
                </ul>
                <!--未登录状态 end-->
            </div>
        </div>
        <div class="login-dialog">
            <el-dialog
                center
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                :before-close="handleClose">
                <div v-if="isRule" class="pop-con">
                    <p>
                        1、活动时间：2022年7月13日  ~   2022年8月12日 <br>
                        2、活动期间，仙友每天都可以送上一条祝福，参与祈福活动<br>
                        3、祝福内容不得涉及政治信息，不得宣传色情、暴力、反动等违规信息，以上行为将直接取消玩家的活动资格 <br>
                        4、仙友可以通过“获奖记录”功能查看自己的中奖明细 <br>
                        5、获得联众秀·沧澜鎏金、联众秀·澜歌幽昙的仙友将于活动结束后统一发放奖励。 <br>
                    </p>
                </div>
                <div v-else class="pop-con">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="60px" class="demo-ruleForm margin-t">
                        <el-form-item label="账号" prop="account">
                            <el-input v-model="ruleForm.account"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input type="password" v-model="ruleForm.password"></el-input>
                        </el-form-item> 
                        <el-button class="animate-pictrue" type="primary" @click="handleLogin('ruleForm')"></el-button>
                    </el-form>
                </div>
            </el-dialog>
        </div>
        <div class="record-dialog">
            <el-dialog
                title="获奖记录"
                :visible.sync="recordVisible"
                :before-close="handleCloseRecord">
                <ul class="scroll">
                    <li v-for="item in recordList" :key="item.id">
                        <img :src="item.itemImg" alt="">
                        <p>{{ item.itemName }}</p>
                    </li>
                </ul>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import vueDanmaku from 'vue-danmaku'
import api from '../../api/api'
import barrageData from '../../api/barrage.json'
import recordData from '../../api/record.json'
import serverlistData from '../../api/serverlist.json'
export default {
    data() {
        return {
            dialogVisible: false,
            recordVisible: false,
            ruleForm: {
                account: '',
                password: ''
            },
            msgForm: {
                gmServer: '',
                roles: '',
                desc: ''
            },
            
            rules: {
                account: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                gmServer: [
                    { required: true, message: '请选择服务器', trigger: 'change' }
                ],
                roles: [
                    { required: true, message: '请选择角色', trigger: 'change' }
                ],
                desc: [
                    { required: true, message: '请输入祝福语', trigger: 'blur' }
                ],
            },
            isRule: false,
            // 登录信息
            loginInfo: {},
            userName: 'ourgame',
            prizeNumber: 0,
            personNumber: 0,
            // 角色list
            roleList: [],
            // 服务器list
            serverList: [],
            dialogTitle: '',
            // 登录状态
            isLogin: false,
            barrageDataList: [],
            recordList: [],
            config: {
                channels: 3, // 轨道数量，为0则弹幕轨道数会撑满容器
                useSlot: true, // 是否开启slot
                loop: true, // 是否开启弹幕循环
                speeds: 100, // 弹幕速度，实际为每秒弹幕走过的像素距离
                fontSize: 20, // 文本模式下的字号
                top: 0, // 弹幕轨道间的垂直间距
                right: 0, // 同一轨道弹幕的水平间距
                debounce: 100, // 弹幕刷新频率（多少毫秒插入一条弹幕，建议不小于50）
                randomChannel: true,
            },
        }
    },
    mounted() {
        // 获取登录状态
        this.getStatus();
        // 获取弹幕list
        this.getBarrageData();
        // 服务器list
        this.getServerList();

        this.getServerStat();

    },
    components: {
        vueDanmaku
    },
    methods: {

        getServerStat(){
            let data={};

            api.getServerStat(data).then(res=>{
                console.log(res);
                    if(res.data.result==1){
                         this.prizeNumber = res.data.data.totalAwardCount || 0;
                        this.personNumber = res.data.data.roleCount || 0;
                    }else{
                        this.$message.error(res.data.message);
                    }
               
            }).catch(res=>{})
        },

        getRoleBy(val){
            this.getRoleData(val);
        },
        /**
         * 获取状态
         */
        getStatus() {
            let data = {};
            api.isLogined(data).then(res=>{
                if(res.status === 200) {
                    if(res.data) {
                        this.userName = res.data.userName || 'ourgame';
                        // prizeNumber:剩余奖品数量 personNumber:已参加人数 
                       
                        if(res.data.result == 0) {
                            // 用户未登录
                            this.isLogin = false;
                        } else {
                            // 成功
                            this.isLogin = true;
                            // 获取角色list
                            //this.getRoleData();
                        }
                    }
                }
            }).catch(res=>{})
        },
        /**
         * 获取服务器list
         */
        getServerList() {

            this.serverList = serverlistData;
           
            // let data = {};
            // api.getServer(data).then(res=>{
            //     if(res.status === 200) {
            //         if(res.data) {
            //             this.serverList = res.data[0].areas[0].servers;
            //         } else {
            //             this.serverList = [];
            //         }
            //     }
            // }).catch(res=>{})
        }, 
        /**
         * 获取角色list
         */
        getRoleData(id) {
            let data = {serverId:id};
            api.getRoleList(data).then(res=>{
                if(res.data.result == 1) {
                    // 获取角色list成功，给roleList赋值
                    this.roleList = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            }).catch(res=>{})
        },
        /**
         * 获取弹幕list
         */
        getBarrageData() {
            // 模拟数据，调用接口后需注释
            //this.barrageDataList = barrageData;
            // api
            let data = {};
            api.getBarrage(data).then(res=>{
                
                if(res.data.result == 1) {
                   
                    this.barrageDataList = res.data.data;

                    console.log(this.barrageDataList);
                } else {
                    this.barrageDataList = [];
                }
            }).catch(res=>{})
        },
        /**
         * 获取弹幕list
         */
        getRecordList() {
            // 模拟数据，调用接口后需注释
            //this.recordList = recordData;
            // api
            let data = {};
            api.getRecord(data).then(res=>{
                if(res.data.result == 1) {
                    this.recordList = res.data.data;
                } else {
                    this.recordList = [];
                }
            }).catch(res=>{})
        },
        /**
         * 登录
         */
        handleLogin(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let data = {
                        name: this.ruleForm.account,
                        password: this.ruleForm.password
                    };
                    api.login(data).then(res=>{
                        if(res.data.result == 1) {
                            // 关闭弹窗
                            this.dialogVisible = false;
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }).catch(res=>{})
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        /**
         * 关闭登录弹窗
         */
        handleClose() {
            this.dialogVisible = false;
            if(!this.isRule) {
                this.$refs['ruleForm'].resetFields();
            }
        },
        /**
         * 关闭获奖记录弹窗
         */
        handleCloseRecord() {
            this.recordVisible = false;
        },
        /**
         * 规则、登录
         */
        activityRules(param) {
            this.dialogVisible = true;
            if(param == 'rules') {
                this.isRule = true;
                this.dialogTitle = '规则';
            } else {
                this.isRule = false;
                this.dialogTitle = '请先登录';
            }
        },
        /**
         * 注销
         */
        logOut() {
            let data = {};
            api.loginOut(data).then(res=>{
                if(res.data.Result == 0) {
                    // 更新用户状态
                    this.getStatus();
                }
            }).catch(res=>{})
            // this.$refs.danmaku.pause();
        },
        /**
         * 获奖记录弹窗
         */
        recordDialog() {
            this.recordVisible = true;
            // 获奖list
            this.getRecordList();
        },
        /**
         * 发送弹幕
         */
        sendMsg(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let data = {
                        serverId: this.msgForm.gmServer,
                        roleName: this.msgForm.roles,
                        barrage: this.msgForm.desc
                    };
                    api.sendBarrage(data).then(res=>{
                        if(res.data.result == 1) {
                            // 发送弹幕成功
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getBarrageData();

                            this.msgForm.desc="";
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }).catch(res=>{})
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>
<style lang="scss">
.login-dialog{
    .el-dialog{
        padding: 0 30px;
        background:url(../../assets/images/barrage/pop-bg.png) center top no-repeat;
        width: 725px;
        height: 439px;
        background-size: 90%;
        box-shadow: none;

        .el-dialog__header{
            padding: 15px 0;
            .el-dialog__title{
                line-height: 50px;
                color: $color-blue4;
                font-size: 26px;
            }
        }
        .el-dialog__headerbtn{
            margin: 14px 10px 0 0;
            width: 32px;
            height: 32px;
            background-color: $color-yellow2;
            border-radius: 50%;
            font-size: 30px;
            color: $black1;
        }
        .el-dialog__body{
            padding: 40px 100px 0 80px;
        }
        .pop-con{
            p{
                line-height: 28px;
                font-size: 12px;
                color: $color-blue4;
            }
            .margin-t{
                padding: 30px 60px;
            }
            .el-button--primary{
                margin: 0 auto;
                border-color: rgba(64, 160, 255, 0);
                width: 125px;
                height: 49px;
                background:url(../../assets/images/barrage/btn7.png) center top no-repeat;
            }
        }
    }
}
.record-dialog{
    .el-dialog{
        background:url(../../assets/images/barrage/pop-bg1.jpg) center top no-repeat;
        width: 888px;
        height: 439px;
        background-size: cover;
        box-shadow: none;
    }
    .el-dialog__header{
        padding: 60px 0 0 0;
        margin: 0 100px;
        border-bottom: 3px solid $color-white;
        line-height: 50px;
        text-align: center;
        span{
            font-size: 20px;
            color: $color-yellow1;
        }
    }
    .el-dialog__headerbtn{
        width: 32px;
        height: 32px;
        background-color: $color-yellow2;
        font-size: 30px;
        color: $black1;
    }
    .el-dialog__body{
        padding: 40px 100px;

        ul{
            height: 160px;
            @include flex-start();
            @include flex-wrap-wrap();
            li{
                margin: 2px;
                width: 80px;
                height: 80px;
                text-align: center;

                img{
                    margin: 0 auto;
                    width: 46px;
                    height: 46px;
                }
                p{
                    width: 80px;
                    line-height: 20px;
                    font-size: 12px;
                    text-align: center;
                    color: $color-white;
                    @include text-ellipsis();
                }
            }
        }
    }
}
/**弹幕 */
.barrage-list{
    min-height: 300px;
    .vue-danmaku{
        height: 460px;
        .danmus .dm{
            background:url(../../assets/images/barrage/msg-bg.png) center top no-repeat;
            background-size: cover;
            width: 520px;
            height: 150px;
            white-space: normal;
            @include flex-align-center();
            .msg{
                padding-left: 60px;
                width: 300px;
                @include flex-space-between();
                @include flex-align-center();
                p{
                    width: 250px;
                    font-size: 18px;
                    color: $black;
                    @include text-ellipsis-row();
                }

                span{
                    background:url(../../assets/images/barrage/award.png) center top no-repeat;
                    background-size: cover;
                    width: 46px;
                    height: 55px;
                    display: block;
                }
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.draw-layer{
    padding: 0;
    .bg-01{
        background:url(../../assets/images/barrage/bg-01.jpg) center top no-repeat;
        height: 926px;
        .banner{
            margin: 0 auto;
            padding: 16% 0 0 0;
            width: 991px;
            .banner-pic{
                background:url(../../assets/images/barrage/slogan1.png) left bottom no-repeat;
                height: 201px;
            }
            .time{
                margin: 0 auto;
                background:url(../../assets/images/barrage/slogan2.png) center top no-repeat;
                height: 117px;
            }
            ul{
            @include flex-center();
            padding: 100px 0 0 0;
            li{
                margin: 0 10px;
                width: 384px;
                height: 102px;
                line-height: 102px;
                text-align: center;
                font-size: 30px;
                color: $color-white;
            }
            .btn1{
                background:url(../../assets/images/barrage/btn1.png) center top no-repeat;
                background-size: cover;
            }
            .btn2{
                background:url(../../assets/images/barrage/btn2.png) center top no-repeat;
                background-size: cover;
            }
        }
        }
    }
    .con{
        margin: 0 auto;
        width: 900px;
    }
    .bg-02{
        position: relative;
        background:url(../../assets/images/barrage/bg-02.jpg) center top no-repeat;
        height: 154px;

        
    }
    .bg-03{
        background:url(../../assets/images/barrage/bg-03.jpg) center top no-repeat;
        height: 1148px;

        .login{
            padding-top: 280px !important;
        }
        .title{
            margin: 0 auto;
            width: 707px;
        }
        .login-status{
            .current-info{
                @include flex-center();
                color: $color-white;
                font-size: 14px;
                p{
                    color: $color-red;
                    margin-right: 20px;
                }
            }
            ul{
                @include flex-center();
                padding: 30px 0;
                li{
                    margin: 0 10px;
                    width: 272px;
                    height: 99px;
                    line-height: 99px;
                    text-align: center;
                    font-size: 30px;
                    color: $color-white;
                    cursor: pointer;
                }
                a{
                    display: block;
                }
            }
            .msg-ruleForm{
                margin: 0 auto;
                max-width: 500px;
                .el-select {
                    width: 500px;
                }
            }
            .send-msg{
                margin: 0 auto;
                background:url(../../assets/images/barrage/btn3.png) center top no-repeat;
                background-size: cover;
                width: 317px;
                height: 171px;
                line-height: 171px;
                text-align: center;
                font-size: 30px;
                color: $color-white;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/special/Barrage.vue